import React from "react";
import { formatCodexMarkerTime } from "../codex/codexEvaluationView";
import CodexReferenceSummary, { hasStructuredReferenceAssessment } from "./CodexReferenceSummary";

function label(value) {
  return String(value || "").replaceAll("_", " ");
}

function ReferenceHistory({ history }) {
  const references = history.filter((item) => item.responseMode === "REFERENCE_V1");
  if (!references.length) return null;
  return <div className="codexEvaluationHistory" aria-label="Reference evaluation history">
    {references.map((item, index) => <span key={item.attemptId || index}>
      Reference · {formatCodexMarkerTime(item.evaluatedAt)} UTC · {label(item.eventAlignment)}
      {item.successScore != null && ` · Successful ${item.successScore}/100`}
      {item.failureScore != null && ` · Failed ${item.failureScore}/100`}
    </span>)}
  </div>;
}

export default function CodexEvaluationCard({ latest, history = [], compact = false, onOpen }) {
  if (!latest) return null;
  if (["LIGHT_V1", "REFERENCE_V1"].includes(latest.responseMode)) {
    return (
      <div className={`codexEvaluationCard compact codexLight${latest.eventAlignment || "NEUTRAL"}`}>
        <div className="codexEvaluationHeader">
          <strong>Codex {latest.responseMode === "REFERENCE_V1" ? "reference comparison" : "check"} · {label(latest.eventAlignment)}</strong>
          <span>{label(latest.trend)} · {label(latest.structure)}</span>
          {latest.confidence !== null && latest.confidence !== undefined
            && <span>Confidence {latest.confidence}%</span>}
          {latest.evaluatedAt && <span>{formatCodexMarkerTime(latest.evaluatedAt)} UTC</span>}
        </div>
        <CodexReferenceSummary evaluation={latest} />
        {latest.responseMode === "REFERENCE_V1" && onOpen
          && <button type="button" className="codexEvaluationOpen" onClick={() => onOpen(latest)}>View reference comparison</button>}
        {!hasStructuredReferenceAssessment(latest) && (latest.evidence || []).length > 0 && (
          <ul className="codexLightEvidence">
            {latest.evidence.map((item, index) => <li key={`e-${index}`}>{item}</li>)}
          </ul>
        )}
        <ReferenceHistory history={history} />
      </div>
    );
  }
  return (
    <div className={`codexEvaluationCard codexEvaluation${latest.verdict || ""} ${compact ? "compact" : ""}`}>
      <div className="codexEvaluationHeader">
        <strong>Codex evaluation · {label(latest.verdict)}</strong>
        {latest.score !== null && latest.score !== undefined && <span>Score {latest.score}</span>}
        {latest.confidence !== null && latest.confidence !== undefined && <span>Confidence {latest.confidence}%</span>}
        <span>{label(latest.timing)}</span>
        {latest.evaluatedAt && <span>{formatCodexMarkerTime(latest.evaluatedAt)} UTC</span>}
      </div>
      {onOpen && <button type="button" className="codexEvaluationOpen" onClick={() => onOpen(latest)}>Read full analysis</button>}
      {latest.summary && <p>{latest.summary}</p>}
      <div className="codexEvaluationSignals">
        {(latest.strengths || []).map((item, index) => <span className="strength" key={`s-${index}`}>{item}</span>)}
        {(latest.risks || []).map((item, index) => <span className="risk" key={`r-${index}`}>{item}</span>)}
      </div>
      {history.length > 0 && (
        <div className="codexEvaluationHistory" aria-label="Codex evaluation history">
          {history.map((item) => (
            <span key={item.attemptId}>{item.responseMode === "REFERENCE_V1"
              ? `Reference · ${label(item.eventAlignment)} · Successful ${item.successScore ?? "n/a"}/100 · Failed ${item.failureScore ?? "n/a"}/100`
              : `${label(item.revision)} · ${label(item.trigger)}`}</span>
          ))}
        </div>
      )}
    </div>
  );
}
